import React, { ReactElement } from 'react'
import { createButtons } from './helpers'
import { IModalActions } from './interface'
import { ModalActionsContainer } from './ModalActionsContainer'
import './styles.scss'

export const ModalActions = (props: IModalActions): ReactElement => {
  return <ModalActionsContainer className={props.className} buttons={createButtons(props)} />
}
